// extracted by mini-css-extract-plugin
export default {"content":"LogoDeleteDialog_content__PrIF8"};